export const EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL;
export const MEDIUM = "https://medium.com/firmachain";
export const TWITTER = "https://x.com/firmachain";
export const TELEGRAM = "https://t.me/firmachain_global";
export const OFFICIAL = "https://firmachain.org";
export const STATION = "https://station.firmachain.io";
export const EXPLORER = "https://explorer.firmachain.dev";
export const API_URL = process.env.REACT_APP_API_URL;
export const COINGECKO = 'https://api.coingecko.com/api/v3/simple/price';
